import { Box, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import { THEME_MODE } from "src/config/constants";
import InterestRateStrategy from "src/view/PoolMonitoring/Overview/AssetConfigOption/InterestRateStrategy";
import ReserveParameter from "src/view/PoolMonitoring/Overview/AssetConfigOption/ReserveParameter";

const useStyle = makeStyles((theme) => ({
  groupBox: {
    borderBottom: `1px solid ${theme.palette.type === THEME_MODE.DARK ? "#3F526F" : "#E1E5EA"}`,
  },
  groupBoxItem: {
    padding: "0.5rem 1rem",
    borderRadius: "6px 6px 0px 0px",
    cursor: "pointer",
  },
  activeGroupBoxItem: {
    backgroundColor: theme.palette.type === THEME_MODE.DARK ? "#7994C1" : "#E1E5EA",
  },
  itemText: {
    color: theme.palette.text.moreDisabled,
    fontSize: "14px",
    fontWeight: 400,
  },
  activeItemText: {
    fontWeight: 500,
    color: "#131C23",
  },
}));

const groupButConfig = ["Reserve Parameter", "Interest Rate Strategy"];

export default function CollapseItems({ asset }) {
  const cls = useStyle();
  const [activeBut, setActiveBut] = useState(0);

  return (
    <Box>
      <Box className={cls.groupBox} display="flex" justifyContent="flex-start" alignItems="center">
        {groupButConfig.map((text, index) => {
          return (
            <Box
              key={text}
              className={clsx(cls.groupBoxItem, { [cls.activeGroupBoxItem]: activeBut == index })}
              onClick={() => setActiveBut(index)}
            >
              <Typography className={clsx(cls.itemText, { [cls.activeItemText]: activeBut == index })}>
                {text}
              </Typography>
            </Box>
          );
        })}
      </Box>
      <Box mt={2}>
        {(() => {
          if (activeBut == 0) return <ReserveParameter asset={asset} />;
          else if (activeBut == 1) return <InterestRateStrategy asset={asset} />;
        })()}
      </Box>
    </Box>
  );
}
